module.exports = __webpack_public_path__ + "img/mb_intro@3x.5d047856.png";